import { debounce, elapsedStart, getCSSVal } from "../inc/helpers";

export default class PageLanding80 {
    init() {
        this._initArtworkScroll();
    }   

    _initArtworkScroll() {  
        const details = document.querySelectorAll(".js-l80-artwork-detail");
        const imgs = document.querySelectorAll(".js-l80-artwork-detail-img");
        const imgsIDs = Array.from(imgs)?.map(img => img.dataset.id);
        
        let top = 0, y = window.scrollY, i = -1;
        let hidden = [...imgsIDs];
        let visible = [];        
        // const getNavH = () => parseFloat(getCSSVal(document.documentElement, "--nav-h"));
        const showImg = (i) => {
            const img = imgs?.[i];            
            if (!img) return;

            if (visible.includes(img.dataset.id)) return;
            
            img.classList.add("is-visible");
            visible.push(img.dataset.id);
            hidden = hidden.filter(id => id !== img?.dataset.id);     
            // console.log("show", i);
        }
        const hideImg = (i) => {
            const img = imgs?.[i];
            if (!img) return;

            if (hidden.includes(img.dataset.id)) return; 
            
            img?.classList.remove("is-visible");
            hidden.push(img.dataset.id);
            visible = visible.filter(id => id !== img?.dataset.id);            
            // console.log("hide", i);
        }
        const hideAll = () => {
            imgs?.forEach(img => img?.classList.remove("is-visible"));
            hidden = [...imgsIDs];
            visible = [];
        }
        const showAll = () => {
            imgs?.forEach(img => !img?.classList.contains("is-visible") && img?.classList.add("is-visible"));
            hidden = [];
            visible = [...imgsIDs];
        }
        const onScroll = () => {            
            const k = window.innerHeight / 2;
            const offsets = Array.from(details).map(detail => ({ 
                top: detail.offsetTop - k, 
                bottom: detail.offsetTop + detail.offsetHeight - k
            }));
            y = window.scrollY;
            const toBottom = y > top;
            const isLast = i === offsets?.length - 1;
            
            if (toBottom && (top >= offsets?.[i]?.top)) {                                
                if (isLast && (top >= offsets?.[i]?.bottom)) {
                    hideAll();

                } else {
                    showImg(i);                
                    i = i + 1 > offsets.length - 1 ? i : i + 1;        
                }
            
            } else if (!toBottom) {
                if (isLast && (top >= offsets?.[i]?.top) && (top <= offsets?.[i]?.bottom)) {
                    showAll();
                
                } else if (top <= offsets?.[i]?.top) {                                            
                    hideImg(i);
                    i = i - 1 > 0 ? i - 1 : 0;
                    i > 0 && showImg(i);
                }
            }                     

            top = y;

            if (i === -1)
                i = 0;
        }         

        elapsedStart(() => {
            const k = window.innerHeight / 2;
            const offsets = Array.from(details).map(detail => ({ 
                top: detail.offsetTop - k, 
                bottom: detail.offsetTop + detail.offsetHeight - k
            }));
            const curr = [...offsets].reverse().find((offset, j) => (y >= offset.top && y <= offset.bottom));
            let flag = false;

            if (curr) {
                i = offsets.indexOf(curr);
            
            } else if (y >= offsets?.[offsets.length - 1]?.bottom) {
                i = offsets.length - 1;
                flag = true;
            }
            
            if (i >= 0 && !flag)
                showImg(i);
        });

        document.addEventListener("scroll", onScroll);
    }
}